<app-active-drafts2 *ngIf="!isMobile" style="margin-bottom:5px;"></app-active-drafts2>
<div class="userAccount" appSameHeight className="sameHeight"  [ngClass]="{'macOS':isMac,'otherOS':!isMac}">
	
<div class="loadingOverlay" *ngIf="isLoading">
	<img src="assets/images/loadinganim.gif">
  </div>
  
   <div class="leftSide" *ngIf="!isMobile"><app-leftside></app-leftside></div>
   <div class="middleSide scrollTable"  [ngClass]="{'sameHeight':!isMobile}"  [ngStyle]="{'width': isMobile?'100%':''}">
   <div class="heading-title">Refer a Friend</div>
   <section class="panel refer-panel">
					<div class="panel-body">
						<section class="panel refer-panel-friend">
							<div class="panel-body" id="referFriend">
								<div class="marketingIng">
								<img class="changeRFimg" [src]="assetURL+'/assets/default/images/referral-bonus-00-dark.png'" alt="" style="max-width: 100%;">
								<span class="referalText">Refer and Earn!</span>
							</div>
								<h4 class="custom-content referral_description"><strong [innerHTML]="userSettings.referral_description"></strong></h4>
								<h4 class="padLeft custom-content promocodeEdit">
									<div class="limiText" *ngIf="!editMode">
										<strong>Your Promo code:</strong>&nbsp;"<span class="boldColor">{{(specialReferCode) ? specialReferCode : userData.referral_code}}</span>"
										<!-- &nbsp;&nbsp;<a href="javascript:void(0);" (click)="editModeCall(true)" class="edit-btn fontBlue">Edit</a> -->
									</div>
									
										<form *ngIf="editMode" action="" class="" name="update" id="update_referral" enctype="multipart/form-data" method="post" accept-charset="utf-8">
											<strong>Your Promo code: </strong>
												<mat-form-field>
													<input matInput (keyup)="keydownReferralCode()" type="text" name="referral_code" [value]="userData.referral_code" required="" #referral_code>
													<input type="hidden" name="form" value="update_referral">
												</mat-form-field>
												<button mat-raised-button type="submit" [disabled]="disableSave" (click)="submitRefferals()" class="mat-primary">Save
													<mat-icon *ngIf="showLoader=='Save'"><mat-spinner color="accent" diameter="20"></mat-spinner></mat-icon>
												</button>&nbsp;
												<a (click)="editModeCall(false);" mat-stroked-button class="mat-basic">Cancel</a>
												<mat-error *ngIf="referral_code_validation!=''" style="position: relative;">{{referral_code_validation }}</mat-error>
										</form>
										
								</h4>
								
								<h4 class="padLeft custom-content referral-link mb0" [ngClass]="{'copied':tooltipText == 'Copied'}">
									<div class="limiText">
										<div class="referral-link-head"><strong>Your referral link:</strong>&nbsp;<span class="fontBlue" #referral_link id="referral_link">{{SITE_URL}}/refer/{{(specialReferCode) ? specialReferCode : userData.referral_code}}</span></div>
										<a href='javascript:void(0);'  [matTooltip]="getTooltipContent()" #copyIcon
										[matTooltipPosition]="tooltipText=='copy'?'above':'below'" (click)='copyToClipboard();' class="pull-right"><i class="far fa-solid fa-copy"></i></a>
									</div> 
								</h4>
								<div class="clearfix"></div>
								<div class="referFormdiv">
									<form [formGroup]="sendReferralForm" (ngSubmit)="sendReferral()" class="form-horizontal bucket-form">
											<label>Refer by email: </label>
												<mat-form-field class="form-control mr-20">
													<input matInput formControlName="email" type="text" placeholder="Enter Email" id="email_refer" name="email" class="form-control refer_field" [ngClass]="{ 'is-invalid': submitted && f.email.errors }"/>
													<mat-error *ngIf="submitted && f.email.errors" class="invalid-feedback">
														<div *ngIf="f.email.errors.required">Email is required</div>
														<div *ngIf="f.email.errors.email">Email must be a valid email address</div>
													</mat-error>
												</mat-form-field>
											<button id="refer_email_send" [disabled]="showLoader=='Send'" mat-raised-button class="mat-primary send_button">Send
												<mat-icon *ngIf="showLoader=='Send'">
													<mat-spinner color="accent" diameter="20"></mat-spinner>
												</mat-icon>
											</button>
											<div class="alert alert-success" *ngIf="sucessMessage!=''">{{sucessMessage}}</div>
											<mat-error *ngIf="referral_code_validation!=''" style="position: relative;">{{referral_send_validation}}</mat-error>
											<a [href]="SITE_URL+'/pages/termsofuse'"><h4 style="color:#ff9800;">Terms and conditions</h4></a>
											<div class="rollover-text pull-right clearfix">{{userSettings.referral_length}} x rollover to cashout bonus</div>	
									</form>
									
								</div>
							
								
							</div>
						</section>
					</div>
                </section>
				 <section class="panel refer-panel">
                    <header class="heading-title panel-heading inrPageTitle refer_frnd">
						Referred Friends
                    </header>
                    <div class="panel-body referPanel">
						<section class="panel">
							<div class="panel-body">
								<div class="panel-top">
									<h4 class="pull-right"><strong>Friends Referred: {{referrals.length}}</strong></h4>
									<h4 class="pull-left"><strong>Total Earned: {{currency_symbol}}{{bonus_amount | number: '1.2-2' | Price}}</strong></h4>
								</div>
								<div class="clearfix"></div>
								<div class="fixed_header">
									<table cellspacing="0" class="referTable table table-striped text-center playerlist teamtable refer_frnd_table">
										<thead>
											<tr class="header tbl-fix-header">
												<th width="40%" class="text-center">Name<i class="zmdi"></i></th>
												<th width="30%" class="text-center">Joined Date&nbsp;<i class="zmdi"></i></th>
												<th width="30%" class="text-center">Contest Played&nbsp;<i class="zmdi"></i></th>
												
											</tr>
										</thead>
										<tbody>
											
												<tr class="even" *ngIf="referrals.length==0">
													<td align="center" colspan="3">
														You haven't refer any user yet.
													</td>
												</tr>
											<tr *ngFor="let record of referrals">
												<td>
													{{record.drafters_id}}
												</td>
												<td>
													{{ record.date_referred * 1000 | date:'MMM d, y'}}
												</td>
												<td>
													{{record.first_join?'Yes':'No'}}
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							
						</section>
					</div>
                </section>
          
   </div>
   <div class="rightSide" *ngIf="!isMobile" [ngClass]="{'sameHeight':!isMobile}">
      <app-resultboard></app-resultboard>
   </div>
</div>